// extracted by mini-css-extract-plugin
export default {"root":"SetupSubscription_root__CQ8jz"};